import { useTypedParams } from 'ClientPortal/src/router/useTypedParams'
import { useDeviationAnalysisComponent } from '../../AssetDeviationAnalysis/AssetDeviationAnalysisComponent.data'
import { useGetValuation } from 'ClientPortal/src/api/Queries/valuations'
import { getValuationStructuresWithIndex } from 'ClientPortal/src/pages/Assets/AssetDetails/AssetDetails.utils'
import { throwOnForbiddenApiError } from 'ClientPortal/src/api/react-query-config'

export function useValuationOverview() {
    const { valuationId } = useTypedParams(['valuationId'])
    const { valuation, isValuationPending } = useGetValuation({ valuationId, throwOnError: throwOnForbiddenApiError })

    const {
        asset,
        showDeviationAnalysis,
        valuationOptions,
        groupedOptionsByLabel,
        assetTitle,
        isValuationsPending,
        isAssetPending,
        hasGroupedValuations,
    } = useDeviationAnalysisComponent()

    return {
        valuationId,
        valuation,
        isValuationPending,
        showDeviationAnalysis,
        valuationOptions,
        groupedOptionsByLabel,
        assetTitle,
        allStructures: getValuationStructuresWithIndex(asset, valuation),
        isValuationsPending,
        isAssetPending,
        hasGroupedValuations,
    }
}
